module.exports = __webpack_public_path__ + "SourceSans3-BoldIt.ttf.a8ac0.woff2";